// @flow
import React, { useEffect, useState } from 'react';
import Box from "@mui/material/Box";
import { withPermissionHOC } from "../../../permission/components/permissionHOC/permissionHOC";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useUserData from "../../../../hooks/user/useUserData";
import axios from "axios";
import { API } from "../../../../helpers/constants";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Skeleton,
    Typography,
    useMediaQuery,
    Grid
} from "@mui/material";

import { LOANS } from "../../locales/namespaces";
import NotesTable from "../../components/tables/notesTable";

const LoanDetails = ({ loanNotes }) => {
    const { t } = useTranslation(LOANS)


    return (
        <Box
            sx={{
                mt: '18px',
                backgroundColor: '#ffffff',
                borderRadius: '10px',
                padding: '0 !important'
            }}
        >
            <NotesTable loanNotes={loanNotes} />
        </Box>
    )
};

export default withPermissionHOC(LoanDetails, ['access_loan_details'])
